let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b4YM8")).then(() => parcelRequire('4x7m1'));